/**
 * Webhook payload schemas (Meta WhatsApp, GoHighLevel, Google Calendar).
 *
 * STATUS: STUBS. Final shapes will land in Epic E2 (integrations) where each
 * provider's exact payload is mapped against the live API. For E1 we expose
 * the placeholder schemas so consumers (apps/api routes, idempotency layer)
 * can import and refer to them without circular dependencies.
 *
 * TODO E2: Replace `Type.Object({})` with real payloads. Each schema must
 *   - capture the dedupe identifier(s) used by `webhooks_log.dedupe_key`
 *   - validate the signature header field name (Meta: x-hub-signature-256)
 *   - mark optional vs required fields per provider docs
 */
import { Type } from '@sinclair/typebox';
/** Meta WhatsApp Cloud API webhook envelope. TODO E2. */
export const MetaWebhookPayload = Type.Object({}, { additionalProperties: true, description: 'Meta WA webhook (E2 stub)' });
/** GoHighLevel webhook envelope (lead created, contact updated, etc.). TODO E2. */
export const GhlWebhookPayload = Type.Object({}, { additionalProperties: true, description: 'GoHighLevel webhook (E2 stub)' });
/** Google Calendar push notification envelope. TODO E2. */
export const CalendarWebhookPayload = Type.Object({}, { additionalProperties: true, description: 'Google Calendar webhook (E2 stub)' });
//# sourceMappingURL=webhook-payloads.js.map